import "./meet-shrey-sharma-dreamforce.scss";
import "../../utilities/script/header";
import "../../utilities/script/footer";
import { countryJSON } from "../../utilities/script/country";

import Swal from "sweetalert2";
import JustValidate from "just-validate";

// Form JS
let contactUsForm = document.querySelector("#contact-form");
const loadingWindow = document.querySelector("#loading-window");
const contactUs = new JustValidate(contactUsForm);

document.addEventListener("DOMContentLoaded", () => {
  if (window.location.hash) {
    console.log(window.location.hash);
    const element = document.querySelector(window.location.hash);
    if (element) {
      setTimeout(() => {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }

  const countrySelect = document.querySelector("#contact-country");
  if (countrySelect && countrySelect.children.length <= 1) {
    const optionsHtml = Object.keys(countryJSON)
      .map(
        (key) =>
          `<option value="${countryJSON[key]}">${countryJSON[key]}</option>`,
      )
      .join("");
    countrySelect.insertAdjacentHTML("beforeend", optionsHtml);
  }

  // FAQ Accordion Toggle
  const faqQuestions = document.querySelectorAll(".faq-question");
  faqQuestions.forEach((question) => {
    question.addEventListener("click", function (e) {
      const parentFaq = e.currentTarget.closest(".faq");
      if (!parentFaq) return;
      const isAlreadyActive = parentFaq.classList.contains("active");

      document.querySelectorAll(".faq").forEach((faq) => {
        faq.classList.remove("active");
      });

      if (!isAlreadyActive) {
        parentFaq.classList.add("active");
      }
    });
  });
});

contactUs
  .addField(contactUsForm.querySelector('[name="full-name"]'), [
    {
      rule: "required",
      errorMessage: "This field is required",
    },
    { rule: "minLength", value: 2 },
    {
      rule: "customRegexp",
      value: /^([a-zA-z,/.-]+)\s([a-zA-z,/.-]+)$/,
      errorMessage: "Value is incorrect",
    },
  ])
  .addField(contactUsForm.querySelector('[name="email"]'), [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      validator: (value) => {
        let emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
        return emailRegex.test(value);
      },
      errorMessage: "Please Enter Valid Email Address",
    },
  ])
  .addField(contactUsForm.querySelector('[name="phone"]'), [
    {
      rule: "required",
      errorMessage: "This field is required",
    },
    {
      rule: "number",
      errorMessage: "Invalid Phone Number",
    },
    { rule: "minLength", value: 9, errorMessage: "Invalid Phone Number" },
    { rule: "maxLength", value: 12, errorMessage: "Invalid Phone Number" },
    {
      rule: "customRegexp",
      value: /^[0-9]+$/,
    },
  ])
  .addField(contactUsForm.querySelector('[name="country"]'), [
    {
      rule: "required",
      errorMessage: "This field is required",
    },
  ])
  .addField(contactUsForm.querySelector('[name="company"]'), [
    {
      rule: "required",
      errorMessage: "This field is required",
    },
  ])
  .addField(contactUsForm.querySelector('[name="job-title"]'), [
    {
      rule: "required",
      errorMessage: "This field is required",
    },
  ])
  .addField(contactUsForm.querySelector('[name="message"]'), [
    {
      rule: "required",
      errorMessage: "This field is required",
    },
  ]);

contactUs.onSuccess(async (event) => {
  try {
    const formData = new FormData(event.target);
    formData.append("website-link", window.location.href);
    formData.append("leadcreate", "leadcreate");
    formData.append("lsource", "book-meeting-salesforce-hulk-dreamforce");

    let fullName = (
      contactUsForm.querySelector('[name="full-name"]').value || ""
    ).trim();
    let nameParts = fullName.split(/\s+/);
    let firstName = nameParts[0] || "";
    let lastName = nameParts.slice(1).join(" ") || firstName;
    formData.append("first-name", firstName);
    formData.append("last-name", lastName);

    let jobTitle =
      contactUsForm.querySelector('[name="job-title"]')?.value || "";
    if (jobTitle) {
      formData.append("profession", jobTitle);
    }

    let msg = contactUsForm.querySelector('[name="message"]')?.value || "";
    if (msg) {
      formData.append("Message", msg);
    }

    if (loadingWindow) {
      loadingWindow.classList.add("show");
    }

    if (typeof waitForRecaptcha === "function") {
      try {
        await waitForRecaptcha();
      } catch {
        if (loadingWindow) {
          loadingWindow.classList.remove("show");
        }
        Swal.fire({
          title: "Error!",
          text: "Something went wrong! Please try again after sometime...",
          icon: "error",
          confirmButtonText: "Close",
        });
        return;
      }
    }

    let response = await fetch("/wp-content/themes/s2-labs/student-form.php", {
      body: formData,
      method: "POST",
    });
    if (!response.ok) throw Error("Something Went Wrong");

    let textData = await response.text();
    if (textData.indexOf("Technical Error") > 0) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong! Please try again after sometime...",
        icon: "error",
        confirmButtonText: "Close",
      });
      window.location.href =
        window.location.href + "?cachebuster=" + new Date().getTime();
      return false;
    }

    Swal.fire({
      title: "Thank you!",
      text: "Our team will get back to you within 24 hours",
      icon: "success",
      confirmButtonText: "Close",
    });
  } catch (err) {
    console.error("Form submit error:", err);
    Swal.fire({
      title: "Error!",
      text: "Something went wrong! Please try again after sometime...",
      icon: "error",
      confirmButtonText: "OK",
    });
  } finally {
    if (loadingWindow) {
      loadingWindow.classList.remove("show");
    }
    contactUsForm.reset();
    if (typeof resetRecaptcha === "function") {
      resetRecaptcha();
    }
  }
});
// Form JS
